import {Link as RouterLink} from 'react-router-dom';
// material
import {styled} from '@mui/material/styles';
import {Card, Container, Link, Stack, Typography} from '@mui/material';
// layouts
import AuthLayout from '../layouts/AuthLayout';
// components
import Page from '../components/Page';
import {MHidden} from '../components/@material-extend';
import {LoginForm} from '../components/authentication/login';

// ----------------------------------------------------------------------

const RootStyle = styled(Page)(({theme}) => ({
    [theme.breakpoints.up('md')]: {
        display: 'flex'
    }
}));

const SectionStyle = styled(Card)(({theme}) => ({
    width: '100%',
    maxWidth: 464,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    margin: theme.spacing(2, 0, 2, 2)
}));

const ContentStyle = styled('div')(({theme}) => ({
    maxWidth: 480,
    margin: 'auto',
    display: 'flex',
    minHeight: '100vh',
    flexDirection: 'column',
    justifyContent: 'center',
    padding: theme.spacing(12, 0)
}));

// ----------------------------------------------------------------------

export default function Login() {
    return (
        <RootStyle title="Verificare comanda">
            <AuthLayout>
                Ești administrator? &nbsp;
                <Link underline="none" variant="subtitle2" component={RouterLink} to="/admin-login">
                    Loghează-te
                </Link>
            </AuthLayout>

            <MHidden width="mdDown">
                <SectionStyle>
                    <Typography variant="h3" sx={{px: 5, mt: 10, mb: 5}}>
                        Bine ai venit!
                    </Typography>
                    <img src="/static/illustrations/illustration_login.webp" alt="login"/>
                </SectionStyle>
            </MHidden>

            <Container maxWidth="sm">
                <ContentStyle>
                    <Stack sx={{mb: 5}}>
                        <Typography variant="h4" gutterBottom>
                            Obține detalii despre comanda ta
                        </Typography>
                        <Typography sx={{color: 'text.secondary'}}>Introduceți email-ul și codul
                            primit prin SMS</Typography>
                    </Stack>

                    <LoginForm/>

                    <MHidden width="smUp">
                        <Typography variant="body2" align="center" sx={{mt: 3}}>
                            Ești administrator? &nbsp;
                            <Link underline="none" variant="subtitle2" component={RouterLink} to="/admin-login">
                                Loghează-te
                            </Link>
                        </Typography>
                    </MHidden>
                </ContentStyle>
            </Container>
        </RootStyle>
    );
}
